import React from 'react';
import IconsUrl from './icons.svg';


const Icon = ({className, symbol, onClick, viewBox='0 0 100 100'}) => (
	<svg viewBox={viewBox} className={className} onClick={onClick}>
		<use xlinkHref={`${IconsUrl}#${symbol}`}></use>
	</svg>
)

Icon.SYMBOL = {
	'LEFT': 'left',
	'RIGHT': 'right',
	'EXIT': 'exit',
  'MENU': 'menu',
  'LOGO': 'logo'
}

export default Icon;


// WEBPACK FOOTER //
// ./components/icon/index.js